/**
 * GapAnalysisCell — the AM's primary conversation tool (handoff §3.6).
 *
 * Renders:
 *   - headline (bold)  — e.g. "D1 → D2 needs +184 met"
 *   - detail   (muted) — e.g. "Rate must reach ≥ 20%. Drivers: Dr. Lowry (412)…"
 *   - top providers list (when present) — Dr. Name (count), Dr. Name (count)
 *
 * The backend pre-formats `headline` and `detail`; we render them as-is.
 * The `top_providers` array is rendered as a comma-joined list of "Name
 * (count)" pairs (the detail string usually already mentions the top
 * driver, so this is for transparency).
 *
 * Renders an em-dash when `gap_analysis` is null (no benchmark / no
 * snapshot).
 */
import type { GapAnalysisDetail } from "@/api/models";

export interface GapAnalysisCellProps {
  gap: GapAnalysisDetail | null | undefined;
}

export function GapAnalysisCell({ gap }: GapAnalysisCellProps) {
  if (!gap) {
    return <span className="text-gray-400">—</span>;
  }
  return (
    <div className="leading-snug">
      <div className="text-sm font-semibold text-gray-800">{gap.headline}</div>
      <div className="mt-0.5 text-xs text-gray-500">{gap.detail}</div>
      {gap.top_providers && gap.top_providers.length > 0 ? (
        <div className="mt-0.5 text-xs text-gray-400">
          {gap.top_providers
            .map((p) => `${p.name} (${p.count})`)
            .join(", ")}
        </div>
      ) : null}
    </div>
  );
}
